import { useEffect } from 'react';
import DraggableSortItem from './draggable-sort-item';

const DraggableSortingContainer = ({ items, onChange, renderItem }) => {

    const handleDrop = (originalIndex, newIndex) => {
        if (originalIndex !== newIndex) {
            console.log('originalIndex ' + originalIndex);
            console.log('newIndex ' + newIndex);
            moveItem(originalIndex, newIndex);
        }
    };

    const moveItem = (fromIndex, toIndex) => {
        const updated = [...items];
        const [moved] = updated.splice(fromIndex, 1);
        updated.splice(toIndex, 0, moved);
        onChange(updated);
    };

    useEffect(() => {
        console.log(items)
    }, [items])

    return (
        <div>
            {items.map((item, index) => (
                <DraggableSortItem
                moveItem={handleDrop}
                renderItem={renderItem}
                item={item}
                index={index}
                key={item.id} />
            ))}
        </div>
    );
}

export default DraggableSortingContainer;